import {ReactNode, useEffect, useState} from 'react';

// third-party
import {IntlProvider, MessageFormatElement} from 'react-intl';

// project import
import {I18n} from "types/ConfigType";
import useConfigContext from "context/useConfigContext";


// load locales files
const loadLocaleData = (locale: I18n) => {
    switch (locale) {
        case 'fr':
            return import('layout/mantis/utils/locales/fr.json');
        case 'ro':
            return import('layout/mantis/utils/locales/ro.json');
        case 'zh':
            return import('layout/mantis/utils/locales/zh.json');
        case 'en':
        default:
            return import('layout/mantis/utils/locales/en.json');
    }
};

// ==============================|| LOCALIZATION ||============================== //

interface Props {
    children: ReactNode;
}

const Locales = ({children}: Props) => {
    const {i18n} = useConfigContext();

    const [messages, setMessages] = useState<Record<string, string> | Record<string, MessageFormatElement[]> | undefined>();

    useEffect(() => {
        loadLocaleData(i18n).then((d: {
            default: Record<string, string> | Record<string, MessageFormatElement[]> | undefined
        }) => {
            setMessages(d.default);
        });
    }, [i18n]);

    return (
        <>
            { messages && (
                <IntlProvider locale={ i18n } defaultLocale="en" messages={ messages }>
                    { children }
                </IntlProvider>
            ) }
        </>
    );
};

export default Locales;
